var Nifty = require("./artifacts/Nifty");

var NiftyFactory = require("./artifacts/NiftyFactory");

module.exports = {
  Nifty: Nifty,
  NiftyFactory: NiftyFactory
};